import { Suspense } from 'react'
import { Box } from '@mui/material'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import { AppShellLayoutContext } from '@/components/AppShell/AppShellLayoutContext'
import { Outlet } from 'react-router-dom'
import { appShellLayoutSx } from './appShellLayoutSx.js'
import { AppShellSecondaryNavSlot } from './AppShellSecondaryNavSlot.jsx'
import PrimaryLeftNavigation from '@/components/PrimaryLeftNavigation'
import IntegrationsModal from '@/components/IntegrationsModal/IntegrationsModal'
import PinLimitDialog from '@/components/SecondaryLeftNavigation/components/PinLimitDialog'
import SettingsModal from '@/components/Settings/SettingsModal/SettingsModal'
import { MAX_PINNED_THREADS } from '@/features/chat/pinnedThreadsConstants'
import { DocumentPreviewProvider } from '@/features/documentPreview/DocumentPreviewContext'
import { ScheduleDetailsProvider } from '@/features/scheduleDetails/ScheduleDetailsContext'
import { ThreadDocumentsProvider } from '@/features/threadDocuments/ThreadDocumentsProvider'
import DesignModeController from './DesignModeController.jsx'

export default function AppShellLayoutView({ layout }) {
  const { secondaryNavProps } = layout

  return (
    <AppShellLayoutContext.Provider value={layout}>
      <Box sx={appShellLayoutSx}>
        <PrimaryLeftNavigation />
        {/* Wraps the nav slot too: the Scheduled rows that open the panel are in
            the sidebar, outside DocumentPreviewProvider's subtree. */}
        <ScheduleDetailsProvider>
          <AppShellSecondaryNavSlot secondaryNavProps={secondaryNavProps} />
          <DocumentPreviewProvider>
            <ThreadDocumentsProvider>
              <DesignModeController />
              <Suspense fallback={<RouteSuspenseFallback />}>
                <Outlet />
              </Suspense>
            </ThreadDocumentsProvider>
          </DocumentPreviewProvider>
        </ScheduleDetailsProvider>
        <SettingsModal />
        <IntegrationsModal />
        {layout.projectDialog}
        <PinLimitDialog
          open={layout.pinLimitDialogOpen}
          onClose={layout.closePinLimitDialog}
          maxPins={MAX_PINNED_THREADS}
        />
      </Box>
    </AppShellLayoutContext.Provider>
  )
}
